module.exports = __webpack_public_path__ + "static/media/bg-header.09baeea4.png";